var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationMaintenance = function SvgIllustrationMaintenance(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--color-alert)",
    viewBox: "0 0 181 180",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 123.2,
    cy: 127,
    r: 27.8,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 123.2 127)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 53.8,
    r: 27.8,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 57.5 53.8)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m134.5 62 2.226-18.668 18.668 2.226-2.226 18.668zM25.5 138.7l4.133-18.34 18.34 4.133-4.133 18.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M92 48.3a43.8 43.8 0 0 0-44.2 43.4c0 23.9 19.8 43.3 44.2 43.3a43.8 43.8 0 0 0 44.2-43.3c0-24-19.8-43.4-44.2-43.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "m107.4 111.6-.7-.1-.5-.4-11.8-11.9-.4-.5-.1-.6v-.6l.5-.6 4-4 .6-.5h.6a1.5 1.5 0 0 1 1.2.4l11.8 11.9.4.5.1.6v.6l-.5.6-4 4.1-.6.4h-.6Zm-28.2 0-.7-.1-.5-.4-4.1-4-.4-.6a1.9 1.9 0 0 1 0-1.3l.4-.5L85 93.6h4.2l1.8-1.8-8.6-8.6h-2.8l-6.2-6.3 5-5 6.3 6.2V81l8.5 8.5 6.4-6.3-3.3-3.3 2.7-2.6h-5.5l-1-1 6.5-6.5 1 1v5.4l2.7-2.7 8.4 8.4q.75.75 1.2 1.8a5.6 5.6 0 0 1 0 4c-.2.7-.5 1.2-1 1.7l-4.1-4.2-2.8 2.8-2.6-2.6-10.3 10.4v4.2l-11.2 11-.5.4h-.6Z"
  })));
};
export default SvgIllustrationMaintenance;